import {ChangeDetectionStrategy, Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Settings} from '@common/core/config/settings.service';
import {WIDGET_LIST} from '../widget-list';
import {Modal} from '@common/core/ui/dialogs/modal.service';
import {ComponentType} from '@angular/cdk/portal';

@Component({
    selector: 'widget-list-modal',
    templateUrl: './widget-list-modal.component.html',
    styleUrls: ['./widget-list-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WidgetListModalComponent {
    widgets = WIDGET_LIST;

    constructor(
        private dialogRef: MatDialogRef<WidgetListModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: {biolinkId: number},
        public settings: Settings,
        private modal: Modal
    ) {}

    openWidgetDialog(component: ComponentType<any>) {
        this.close();
        this.modal.open(component, this.data);
    }

    close() {
        this.dialogRef.close();
    }
}
